// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/slot.css
// module id = 246
// module chunks = 1